import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lobby-layout" }
const _hoisted_2 = { class: "panel-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "actions"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "dev-controls"
}

import { computed, ref } from 'vue';
import type { PropType } from 'vue';
import { useGameStore } from '@/stores/gameStore';
import type { PlayerPublic, Roles } from '@/types/game';
import PlayerList from '@/views/wait/PlayerList.vue';
import SettingsPanel from '@/views/wait/SettingsPanel.vue';
import ApiKeyModal from '@/views/wait/ApiKeyModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LobbyLayout',
  props: {
    players: { type: Array as PropType<PlayerPublic[]>, required: true },
    roles: { type: Object as PropType<Roles>, required: true },
    initialEnvironment: { type: [String, null] as PropType<string | null>, required: true },
    isHost: { type: Boolean, required: true },
    playerCount: { type: Number, required: true },
    isLoading: { type: Boolean, required: true },
},
  emits: ['updateRoles', 'updateEnvironment'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const gameStore = useGameStore();
const showKeyModal = ref(false);
const canStartGame = computed(() => {
    const totalRoles = Object.values(props.roles).reduce((sum, count) => sum + count, 0);
    return props.playerCount === totalRoles && totalRoles > 0;
});

const startGameButtonText = computed(() => {
    if (!canStartGame.value) {
        if (props.playerCount === 0) return 'Ожидание игроков';
        const totalRoles = Object.values(props.roles).reduce((sum, count) => sum + count, 0);
        if (props.playerCount !== totalRoles) {
            return 'Кол-во игроков и ролей не совпадает';
        }
        return 'Распределите роли';
    }
    return 'Начать игру';
});

const startGame = () => {
    if (props.isHost && canStartGame.value) {
        gameStore.startGame();
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PlayerList, {
      players: __props.players,
      roles: __props.roles
    }, null, 8, ["players", "roles"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SettingsPanel, {
        "initial-roles": __props.roles,
        "initial-environment": __props.initialEnvironment,
        "is-host": __props.isHost,
        "player-count": __props.playerCount,
        "is-loading": __props.isLoading,
        onUpdateRoles: _cache[0] || (_cache[0] = ($event: any) => (emit('updateRoles', $event))),
        onUpdateEnvironment: _cache[1] || (_cache[1] = ($event: any) => (emit('updateEnvironment', $event)))
      }, null, 8, ["initial-roles", "initial-environment", "is-host", "player-count", "is-loading"]),
      (__props.isHost)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: startGame,
              class: "btn start-game-btn",
              disabled: !canStartGame.value || __props.isLoading
            }, _toDisplayString(startGameButtonText.value), 9, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      (__props.isHost)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showKeyModal.value = true)),
              class: "key-btn",
              title: "Set Custom API Key"
            }, " 🔑 ")
          ]))
        : _createCommentVNode("", true),
      (showKeyModal.value)
        ? (_openBlock(), _createBlock(ApiKeyModal, {
            key: 2,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (showKeyModal.value = false))
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})